import Vue from "vue";

export default Vue.extend({
  name: 'PresidentsGoalReport',
  data() {
    return {
      inputParams: {
        year: 0
      }
    }
  },
  created() {
    this.inputParams.year = new Date().getFullYear();
  },
  methods: {
    clearInputParams() {
      this.inputParams = {
        year : new Date().getFullYear()
      }
    }
  }
}
);



// WEBPACK FOOTER //
// ./src/components/reports/presidentsgoal/PresidentsGoalReport.ts